import { money } from "../../lib/api";

const day = (s) => (s ? new Date(`${s}T12:00:00`).toLocaleDateString("fr-CA", { weekday: "long", day: "numeric", month: "long" }) : "");

export function ThankYou({ o }) {
  const a = o.address || {};
  const w = o.delivery_window;
  return (
    <div className="mt-10 grid md:grid-cols-[1fr_320px] gap-10 rise" data-testid="thank-you">
      <div>
        <div className="label-xs mb-3">Commande {o.number}</div>
        <ul className="divide-y divide-black/10 border-y border-black/10" data-testid="thank-you-items">
          {o.items.map((i) => (
            <li key={i.variant_id} className="py-4 flex justify-between gap-4 text-sm">
              <span><span className="block">{i.title}</span><span className="text-muted-foreground">{i.variant_name} · Qté {i.qty}</span></span>
              <span className="font-mono whitespace-nowrap">{money(i.unit_price_local * i.qty, o.currency)}</span>
            </li>
          ))}
        </ul>
        <div className="text-sm space-y-2 mt-4">
          <div className="flex justify-between"><span>Sous-total</span><span className="font-mono">{money(o.subtotal, o.currency)}</span></div>
          <div className="flex justify-between"><span>Livraison</span><span>Offerte</span></div>
          {o.discount > 0 && <div className="flex justify-between" data-testid="thank-you-discount"><span>Code {o.promo_code} (déjà déduit)</span><span className="font-mono">−{money(o.discount, o.currency)}</span></div>}
          {(o.taxes || []).map((t) => <div key={t.name} className="flex justify-between text-muted-foreground"><span>{t.name}</span><span className="font-mono">{money(t.amount, o.currency)}</span></div>)}
          <div className="flex justify-between text-base pt-2 border-t border-black/10"><span>Total payé</span><span className="font-mono" data-testid="thank-you-total">{money(o.payment?.amount_captured || o.total, o.currency)}</span></div>
        </div>
      </div>
      <aside className="space-y-6 text-sm">
        <div className="border border-black/10 p-5" data-testid="thank-you-delivery">
          <div className="label-xs mb-2">Livraison estimée</div>
          <p className="font-serif-edit text-xl first-letter:uppercase">{w ? `${day(w.from)} – ${day(w.to)}` : day(o.delivery_estimate)}</p>
          <p className="text-muted-foreground mt-2">Livraison gratuite. Vous recevrez un courriel avec le numéro de suivi dès l'expédition.</p>
        </div>
        <div className="border border-black/10 p-5" data-testid="thank-you-address">
          <div className="label-xs mb-2">Adresse de livraison</div>
          <p>{a.first_name ? `${a.first_name} ${a.last_name}` : a.name}<br />{a.line1}{a.line2 ? `, ${a.line2}` : ""}<br />{a.city} ({a.province}) {a.postal_code}<br />Canada</p>
        </div>
        <p className="text-muted-foreground">Une confirmation a été envoyée à {o.email}. Retours acceptés sous {o.return_days || 30} jours.</p>
        {o.account_created && <p className="border border-black/10 p-4" data-testid="thank-you-account">Votre compte client a été créé avec votre courriel et votre téléphone. Un courriel vous permet de choisir votre mot de passe pour suivre vos commandes.</p>}
      </aside>
    </div>
  );
}
